module.exports = __webpack_public_path__ + "static/image-6930d3c473940fac2fe5dbeafef04911.jpeg";